import React, { memo } from 'react';
import styles from './iconButton.module.scss';
import { CircularProgress } from '@material-ui/core';

const iconButton = ({ className, onClick, children, loading = false }) => {

    if (!loading) {
        return (
            <div className={`${className} ${styles.content}`}>
                < button className={` ${styles.button}`} onClick={onClick} >
                    {children}
                </button >
            </div>

        );
    } else {
        return (
            <div className={`${className} ${styles.content} `}>
                < button className={`${styles.button} ${styles.loading} `}>
                    {children} <CircularProgress className={styles.loader} />
                </button >
            </div>

        );
    }

}

export default memo(iconButton);